var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_message--warning"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col"},[_c('i',{staticClass:"mdi mdi-alert"}),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }